// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kOYU2","newExpiryDate":"styles_newExpiryDate__3oL2u","footer":"styles_footer__1icb5"};